import { useQuery } from "@tanstack/react-query";
import { getAdminRoles } from "@/services/role-access.service";

export const useAdminRoles = (enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["admin-roles"],
    queryFn: getAdminRoles,
    enabled,
    ...options,
  });
};
